import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { DataService, Response } from "../../dataService/data.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalVariable } from "../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgbRatingConfig } from "@ng-bootstrap/ng-bootstrap";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  NgForm,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-review-experience",
  templateUrl: "./review-experience.component.html",
  styleUrls: ["./review-experience.component.scss"],
})
export class ReviewExperienceComponent implements OnInit {
  @ViewChild("errorModal", { static: true }) errorModal: ElementRef;
  @ViewChild("zceppaReviewModal", { static: true })
  zceppaReviewModal: ElementRef;
  @ViewChild("thankyoumodal", { static: true }) thankyoumodal: ElementRef;
  public loading = false;

  constructor(
    private HttpService: DataService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    config: NgbRatingConfig
  ) {
    config.max = 5;
    config.readonly = true;
  }

  linkValid: boolean = false;
  reviewsby = [];
  messageSuccess: boolean = false;
  private BASE_URL = GlobalVariable;
  slug_value: String;
  error_slug: boolean = false;
  success_slug: boolean = false;
  error_message: String;
  success_data: any;
  feedback: String;
  selected_rating: number = 0;
  ratings: number = 0;
  readonly: boolean = false;
  logo_url: String;
  business_name: String;
  customer_name: String;
  load_zceppa: boolean;

  ngOnInit() {
    this.loading = true;
    // this.spinnerService.show();
    //console.log(this.logo_url);
    let res: Response;
    this.calltimeout();
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    const json_data = {
      slug: this.slug_value,
    };

    const userInfo = this.HttpService.get(
      this.BASE_URL.FEEDBACK_SLUG_DATA,
      null,
      this.slug_value
    );
    userInfo.subscribe((data: Response) => {
      res = data;
      //console.log(res.data);
      this.business_name = res.data["business_name"];
      this.logo_url = res.data["business_logo"];
      this.customer_name = res.data["contact_name"];
    });

    const data_service = this.HttpService.postjson(
      this.BASE_URL.SMS_SLUG_URL,
      json_data
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        // this.spinner.stop();
        this.error_message = error.error.message;
        this.error_slug = true;
        this.success_slug = false;
        // this.modalService.open(this.errorModal,  { size:  'lg',
        //   windowClass:  'modal-xl',  centered:  true
        // });
      },
      () => {
        // this.spinner.stop();
        this.success_slug = true;
        this.error_slug = false;
        this.success_data = res.data;
        // console.log(this.error_slug);
        // console.log(this.success_slug);
        this.load_zceppa = res.data["zceppa"].load_zceppa;
        if (
          res.data["google"] !== undefined &&
          res.data["google"].google_link !== null
        ) {
          this.reviewsby.push({
            id: 1,
            reviewby: "Google",
            image: "assets/images/social/google.png",
            class: "reviewgoogle  ",
            link: res.data["google"].google_link,
            source: true,
          });
        }
        if (
          res.data["facebook"] !== undefined &&
          res.data["facebook"].fb_link !== null
        ) {
          this.reviewsby.push({
            id: 2,
            reviewby: "Facebook",
            image: "assets/images/social/facebook.png",
            class: "reviewfacebook  ",
            link: res.data["facebook"].fb_link,
            source: true,
          });
        }
        if (res.data["custom"] !== undefined) {
          res.data["custom"].forEach((val: any, key: any) => {
            if (val.type === "zomato") {
              this.reviewsby.push({
                id: 3,
                reviewby: "Zomato",
                image: "assets/images/zomato_white_logo_new.svg",
                class: "reviewzomato  ",
                link: val.url,
                source: true,
              });
            }
            if (val.type === "trip_advisor") {
              this.reviewsby.push({
                id: 4,
                reviewby: "TripAdvisor",
                image: "assets/images/tripadvisor.svg",
                class: "reviewtrip  ",
                link: val.url,
                source: true,
              });
            }
            if (val.type === "practo") {
              this.reviewsby.push({
                id: 5,
                reviewby: "Practo",
                image: "assets/images/practo.svg",
                class: "reviewpracto  ",
                link: val.url,
                source: true,
              });
            }
            if (val.type === "just_dail") {
              this.reviewsby.push({
                id: 6,
                reviewby: "Just Dial",
                image: "assets/images/jdlogosvg.svg",
                class: "reviewjustdial  ",
                link: val.url,
                source: true,
              });
            }
          });
        }
        setTimeout(() => {
          if (this.load_zceppa === true) {
            this.reviewsby.push({
              id: 7,
              reviewby: "Zceppa",
              image: "assets/images/favicon.png",
              class: "reviewzceppa  ",
              link: "INTERNAL",
              source: true,
            });
          }
          /** spinner ends after 5 seconds */
          this.loading = false;
        }, 2000);
      }
    );
  }

  calltimeout() {
    setTimeout(() => {
      this.messageSuccess = true;
      // this.spinner.stop();
    }, 13000);
  }

  /**
   * Post review link
   *
   * @param {*} link
   * @memberof ReviewExperienceComponent
   */
  postReviewBy(link) {
    if (link === "INTERNAL") {
      this.ZceppaReviewModal();
    } else {
      window.location.replace(link);
    }
  }

  ZceppaReviewModal() {
    this.modalService.open(this.zceppaReviewModal, {
      size: "sm",
      windowClass: "modalfeedback",
      centered: true,
    });
  }

  thankyouModal() {
    let res: Response;
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    if (this.feedback === undefined || this.feedback === "") {
      this.toastrService.error("Please Enter Feedback");
      return;
    }
    if (this.selected_rating === 0) {
      this.toastrService.error("Please Choose Ratings");
      return;
    }
    const json_data = {
      slug: this.slug_value,
      feedback_text: this.feedback,
      feedback_star: this.selected_rating,
    };
    const data_service = this.HttpService.postjson(
      this.BASE_URL.SMS_SLUG_REQUEST_URL,
      json_data
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {},
      () => {
        if (res.code === 200 || res.code === 201) {
          this.modalService.dismissAll(this.zceppaReviewModal);
          this.modalService.open(this.thankyoumodal, {
            size: "sm",
            windowClass: "modalfeedback",
            centered: true,
          });
          this.feedback = "";
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }

  closeModal() {
    this.modalService.dismissAll(this.thankyoumodal);
  }

  /**
   *Common toastr for success function
   *
   * @param {string} msg
   * @memberof ReviewExperienceComponent
   */
  showSuccess(msg: string) {
    this.toastrService.success(msg);
  }

  /**
   * Common toastr for error function
   *
   * @param {string} msg
   * @memberof ReviewExperienceComponent
   */
  showError(msg: string) {
    this.toastrService.error(msg);
  }
}
